import React from 'react';
import { Popover, Button, Select, Icon, Checkbox } from 'antd';

const { Option } = Select;

export const AgencyId = ({
  onChange,
  agencies = [],
  isCopyright,
  setIsCopyright,
  params
}) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8 }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        {!params?.order && <Icon type='column-height' />}
        {params?.order === 'asc' && <Icon type='sort-ascending' />}
        {params?.order === 'desc' && <Icon type='sort-descending' />}
      </div>
      <div style={{ marginBottom: 8 }}>
        <Checkbox
          onChange={(e) => {
            if (e.target.checked) {
              onChange({ ...params, value: agencies });
            } else {
              onChange({ ...params, value: [] });
            }
          }}
          checked={
            agencies &&
            agencies?.length &&
            agencies?.every((agency) => (params?.value || []).includes(agency))
          }
        >
          All
        </Checkbox>
      </div>

      <div style={{ marginBottom: 8 }}>
        <Checkbox
          checked={isCopyright}
          onChange={(e) => {
            if (e.target.checked) {
              setIsCopyright(true);
            } else {
              setIsCopyright(false);
            }
          }}
        >
          Copyright Registered
        </Checkbox>
      </div>

      <Select
        value={params?.value}
        mode='multiple'
        style={{ width: '165px' }}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().startsWith(input.toLowerCase())
        }
        onChange={(value) => {
          onChange({ ...params, value });
        }}
        allowClear
        placeholder='Agency ID'
      >
        {agencies &&
          agencies?.length &&
          agencies?.map((agency) => (
            <Option key={agency} value={agency}>
              {agency}
            </Option>
          ))}
      </Select>
    </>
  );

  return (
    <Popover content={content} title='Agency Id' trigger='click'>
      <Button className='sighting-filter' style={{ width: '8%' }}>
        Agency Id
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
